import NextHead from 'next/head';
import getConfig from '../common/config';
import { title } from '../common/libs/metadata';

function PageHead({
  description,
  imgUrlSuffix,
  pageUrlSuffix,
}: {
  description: string;
  imgUrlSuffix: string;
  pageUrlSuffix: string;
}) {
  const {
    publicRuntimeConfig: { slideWebBaseUrl },
  } = getConfig();
  const imgUrl = `${slideWebBaseUrl}${imgUrlSuffix}`;
  const pageUrl = `${slideWebBaseUrl}${pageUrlSuffix}`;
  return (
    <NextHead>
      <title>{title(description)}</title>
      <link rel="canonical" href={pageUrl} />
      <meta name="description" content={description || undefined} />
      <meta property="og:title" content={title(description)} key="og:title" />
      <meta property="og:type" content="article" key="og:type" />
      <meta property="og:image" content={imgUrl || undefined} key="og:image" />
      <meta property="og:url" content={pageUrl} key="og:url" />
      <meta
        property="og:description"
        content={description || undefined}
        key="og:description"
      />
      <meta name="twitter:image" content={imgUrl || undefined} />
    </NextHead>
  );
}

export default PageHead;
